import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FooterLinkViewerModels } from '@medsurf/flat-models';
import { AppSharedFacade, NodeSharedFacade } from '@medsurf/flat-facades';

@Component({
    selector: 'medsurf-subjects',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './subjects.component.html',
    styleUrls: ['./subjects.component.scss'],
    standalone: false
})
export class SubjectsComponent {
  /**
   * TODO move to route data
   * Members
   */
  public footerLinks: FooterLinkViewerModels.FooterLink[] = [
    {title: 'DATENSCHUTZERKLÄRUNG', url: 'privacy'},
    {title: 'IMPRESSUM', url: 'impressum'}
  ];

  /**
   * Constructor
   *
   * @param appSharedFacade
   * @param nodeSharedFacade
   */
  public constructor(public appSharedFacade: AppSharedFacade,
                     public nodeSharedFacade: NodeSharedFacade) {
  }
}
